import { ContactApi } from "../../../Shared/Constants/api";
import axiosInstance from "../../../Shared/Utils/axiosInstance";
import { parseResponseError } from "../../../Shared/Utils/errorUtils";

export const getAsesorsApi = async () => {
  try {
    let response = await axiosInstance.get(
      `${ContactApi}?contact_charge_name=ASESOR`
    );

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};
